// extracted by mini-css-extract-plugin
export var container = "Xsklh";
export var containerDenseless = "CvKRp";
export var containerDenselessNoMargin = "jElSS";
export var fullBleed = "Fr1kM";
export var neutralPaletteBackground = "VJZZC";